import { FC } from 'react'
import { UserBlockReason } from '~gql-types/graphql'
import { ExpandableSection } from '../archived/expandable-section'

interface BlockedFromBoardExpandablesProps {
  reason: UserBlockReason
  networkName: string
}

export const BlockedFromBoardExpandables: FC<
  BlockedFromBoardExpandablesProps
> = ({ reason, networkName }) => {
  if (reason === UserBlockReason.OptOut) {
    return (
      <>
        <ExpandableSection message="How did I opt out of paying for Yellowdig?">
          In your LMS, you chose the{' '}
          <strong className="font-semibold">Do Not Pay for Yellowdig</strong>{' '}
          option when prompted to pay for a Yellowdig membership.
        </ExpandableSection>
        <ExpandableSection message="Who should I contact with questions about this status?">
          For questions regarding this restriction, please contact the{' '}
          <strong className="font-semibold">Community Owner</strong> or a{' '}
          <strong className="font-semibold">
            Yellowdig Administrator for {networkName}
          </strong>
          .
        </ExpandableSection>
        <ExpandableSection message="Can I rejoin a community after opting out?">
          Yes, to rejoin, go to your Learning Management System (LMS) and select{' '}
          <strong className="font-semibold">Pay for Yellowdig</strong>.
        </ExpandableSection>
      </>
    )
  }

  return (
    <>
      <ExpandableSection message="Can I unblock myself?">
        No, only the <strong className="font-semibold">Community Owner</strong>{' '}
        can unblock you. If you believe this was a mistake, you may reach out to
        them for further assistance.
      </ExpandableSection>
      <ExpandableSection message="Who should I contact if I have questions about my blocked status?">
        Please contact the{' '}
        <strong className="font-semibold">Community Owner</strong> for more
        information regarding your blocked status and potential next steps.
      </ExpandableSection>

      <ExpandableSection message="How can I avoid being blocked in the future?">
        To prevent being blocked, follow the community guidelines and engage
        respectfully with others. If you&apos;re unsure about what lead to this
        block, reach out to the{' '}
        <strong className="font-semibold">Community Owner</strong> for
        clarification.
      </ExpandableSection>
    </>
  )
}
